export default __webpack_public_path__ + "static/images/onlyguides/full_yasuo.png";